var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMonitoringIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_248_4584)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.871 28.4194L12.175 35.0725H25.3908L22.1565 28.4194",
    stroke: "#4F9BE2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2194 27.5627H3.5415V6.92773H34.0242V10.2705",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3169 28.4194L38.4584 34.534",
    stroke: "#27C3E2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.02783 20.5663L10.1657 15.0949L13.2519 22.1311L16.8332 11.8208L20.7181 14.6613",
    stroke: "#27C3E2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4455 29.496C34.1418 29.496 37.9489 25.6889 37.9489 20.9926C37.9489 16.2963 34.1418 12.4893 29.4455 12.4893C24.7492 12.4893 20.9421 16.2963 20.9421 20.9926C20.9421 25.6889 24.7492 29.496 29.4455 29.496Z",
    stroke: "#276AE2",
    strokeWidth: 3,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_248_4584"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMonitoringIcon);
export default __webpack_public_path__ + "static/media/MonitoringIcon.3cf89ad0497da75b57beda532ba4981b.svg";
export { ForwardRef as ReactComponent };